import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {NotificationService} from '../../../shared/utils/notification.service';
import {IsbnService} from '../../services/isbn.service';
import {IsbnModel, IsbnNotValidatedPair, IsbnResult} from '../../models/isbn.model';
import {IsbnUtils} from '../../utils/isbn-utils';
import * as Tesseract from 'tesseract.js'
import {ConfirmationService} from 'primeng/api';
import {I18nService} from '../../../shared/i18n';
import {AppCommunicationService} from '../../services/app-communication.service';
import {PRODUCTION_BUILD, DEVAPI_BUILD, SYSTEM_NAME} from 'app/+app-custom/app.settings';
import {getErrorByCode} from '../../constants';
import {BASE_FRONTEND_URL, getBaseFrontendUrl} from '../../app.urls';

@Component({
    selector: 'app-add-isbn-view',
    templateUrl: './add-isbn-view.component.html',
    styleUrls: ['./add-isbn-view.component.scss']
})

export class AddIsbnViewComponent implements OnInit {
    validatedISbn: IsbnModel[] = [];
    isNewIsbnValid = true;
    isOcrWorking = false;
    isIsbnDuplicated = false;
    selectedfile = null;
    inputText = '';
    recognitionProgress = 0;
    tesseract;
    displayParsingErrorDialog = false;
    multipleAddIsbn = '';
    progressBarInfromation = {
        percent: 0,
        activity: 'Nothing'
    };
    addMultiple = false;

    @ViewChild('inputFile') inputFile;

    constructor(private isbnService: IsbnService,
                private cdr: ChangeDetectorRef,
                private confirmationService: ConfirmationService,
                private i18nService: I18nService,
                private notificationService: NotificationService,
                private _appCommunicationService: AppCommunicationService) {
    }

    ngOnInit() {
        const frontendUrl = getBaseFrontendUrl(SYSTEM_NAME);
        this.tesseract = Tesseract.create({
            workerPath: frontendUrl + '/assets/tesseractjs/worker.js',
            langPath: frontendUrl + '/assets/tesseractjs/lang/',
            corePath: frontendUrl + '/assets/tesseractjs/index.js'
        });

        this._appCommunicationService.loadingOff();
    }

    validateIsbn(newIsbn: string) {
        if (this.checkDirtyIsbn(newIsbn)) {
            const cleanIsbn = newIsbn.split('-').join('');
            const isbnToAdd = new IsbnModel();
            isbnToAdd.cleanNumber = cleanIsbn;
            isbnToAdd.dirtyNumber = newIsbn;
            this.validatedISbn.push(isbnToAdd);
            this.isNewIsbnValid = true;
            this.inputText = '';
        }
    }

    checkDirtyIsbn(isbn): boolean {
        // empty isbn
        if (isbn === '') {
            this.isNewIsbnValid = true;
            this.isIsbnDuplicated = false;
            return false;
        }

        // valid dirty isbn example : 978-9955-598-18-3
        const cleanIsbn = isbn.split('-').join('');


        if (this.isIsbnDuplicated = this.validatedISbn.some(x => x.cleanNumber === cleanIsbn)) {
            this.isNewIsbnValid = true;
            return false;
        }
        return this.isNewIsbnValid = IsbnUtils.isDirtyIsbnValid(isbn);

    }

    submitForm() {
        this.isbnService.bulkCreateIsbns(this.validatedISbn)
            .subscribe((result: IsbnResult[]) => {
                    this.checkSavedIsbns(result);
                },
                (err) => {
                    console.error(err);
                    if (err.error === 'Cannot insert duplicate ISBN') {
                        this.showIsbnSavingError('duplicateIsbnError');
                    } else {
                        this.showIsbnSavingError('somethingIsWrongError');
                    }

                });
    }

    checkSavedIsbns(isbns: IsbnResult[]) {
        const withError = isbns.filter(i => !i.succecss);

        if (withError && withError.length > 0) {
            console.log(withError)

            let errorDialogText = '<ul id="isbn-list-error">';

            withError.forEach(err => {
                errorDialogText += '<li>' + err.isbn.dirtyNumber + ' : ' + this.i18nService.getTranslation(getErrorByCode(err.errorCode)) + '</li>';
            })

            errorDialogText += '</ul>';

            this.notificationService.smartMessageBox({
                title: this.i18nService.getTranslation('error'),
                content: this.i18nService.getTranslation(`
                        ${this.i18nService.getTranslation('Nasledujúce ISBN sa nepodarilo uložiť')}: ${errorDialogText}
                        `),
                buttons: '[' + this.i18nService.getTranslation('Ok') + ']'
            }, (ButtonPressed) => {
                if (ButtonPressed === this.i18nService.getTranslation('Ok')) {
                    this.resetForm();
                }
            });

        } else {
            this.showIsbnSaveded();
            this.resetForm();
        }
    }

    showIsbnSaveded() {
        this.notificationService.smallBox({
            title: this.i18nService.getTranslation('saved'),
            color: '#659265',
            content: this.i18nService.getTranslation('IsbnHasBeenSaved'),
            timeout: 10000
        });

    }

    showIsbnSavingError(content) {
        content = this.i18nService.getTranslation(content)
        this.notificationService.smallBox({
            title: this.i18nService.getTranslation('error'),
            color: '#923837',
            iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
            content: content,
            timeout: 5000
        });
    }

    resetForm() {
        this.validatedISbn = [];
        this.isNewIsbnValid = true;
        this.isIsbnDuplicated = false;
        this.selectedfile = null;
        this.isOcrWorking = false;
        this.inputText = '';
        this.recognitionProgress = 0;
    }

    onFileSelected(event) {

        this.selectedfile = event.target.files[0];
        // disable elements and show progress bat
        this.isOcrWorking = true;
        this.tesseract.recognize(this.selectedfile, {
            lang: 'eng'
        })
            .progress(this.onProgressUpdate)
            .catch(err => console.error(err))
            .then(this.onRecognizeCompleted)
    }

    onProgressUpdate = (progress) => {

        if (progress.status !== 'recognizing text') {
            this.progressBarInfromation.activity = this.i18nService.getTranslation('loadingOrc');
            this.progressBarInfromation.percent = 0;
        } else {
            this.progressBarInfromation.activity = this.i18nService.getTranslation('recognizeText');
            this.progressBarInfromation.percent = progress.progress * 100;
        }

        this.cdr.detectChanges();
    }

    onRecognizeCompleted = (result) => {

        const recognizedIsbn: IsbnModel[] = IsbnUtils.parseIsbn(result);
        // if (!(recognizedIsbn.length === 100)) {
        //     this.notificationService.smallBox({
        //         title: this.i18nService.getTranslation('error'),
        //         color: '#923837',
        //         content: this.i18nService.getTranslation('parsingError'),
        //         timeout: 10000
        //     });
        // }
        this.inputFile.nativeElement.value = '';
        this.validatedISbn = [...this.validatedISbn, ...recognizedIsbn];
        this.isOcrWorking = false;
        this.cdr.detectChanges();
    }

    onReset() {
        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmRemoveIsbns'),
            buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                this.i18nService.getTranslation('Yes') + ']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                this.resetForm();
            }
        });
    }

    OnParseMultiple() {

        let cleanInput = this.multipleAddIsbn.split(' ').join('');
        cleanInput = cleanInput.split('\n').join('');
        let uncheckedIsbnArray = cleanInput.split(';');
        uncheckedIsbnArray = uncheckedIsbnArray.filter(line => line !== '');
        const unvalidIsbnPairs: IsbnModel[] = [];
        uncheckedIsbnArray.forEach(line =>
            unvalidIsbnPairs.push({
                    dirtyNumber: line,
                    cleanNumber: line.split('-').join('')
                }
            )
        );
        if (unvalidIsbnPairs.length === 0 || unvalidIsbnPairs.some(p => false === IsbnUtils.isDirtyIsbnValid(p.dirtyNumber))) {
            this.displayParsingErrorDialog = true;
        } else {
            this.multipleAddIsbn = '';
            this.validatedISbn = [...this.validatedISbn, ...unvalidIsbnPairs];
        }

        //  console.log(unvalidIsbnPairs);

    }
}




// WEBPACK FOOTER //
// ./src/app/+app-custom/views/add-isbn-view/add-isbn-view.component.ts